import React from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

interface PricingCardProps {
  name: string;
  description: string;
  price: number;
  features: React.ReactElement;
  upgradeButton: React.ReactElement;
  highlighted: string;
}

const PricingCard = ({
  name,
  description,
  price,
  features,
  upgradeButton,
  highlighted
}: PricingCardProps) => {
  return (
    <div>
      {highlighted && (
        <div className={styles.highlight}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="12.078"
            viewBox="0 0 11 12.078">
            <path
              id="Path_71"
              data-name="Path 71"
              d="M9.089,2.169a.458.458,0,0,0-.655-.083A5.954,5.954,0,0,0,6.272,5.86,4.612,4.612,0,0,1,5.23,4.812a.458.458,0,0,0-.7-.05A5.5,5.5,0,1,0,10.75,3.543a4.559,4.559,0,0,1-1.66-1.374Zm1.7,7.311a2.292,2.292,0,1,1-4.469-.716,3.627,3.627,0,0,0,1.3.611A3.661,3.661,0,0,1,8.8,7.208,2.292,2.292,0,0,1,10.792,9.48Z"
              transform="translate(-3.002 -1.985)"
              fill="#fff"
              fillRule="evenodd"
            />
          </svg>
          {highlighted}
        </div>
      )}
      <div className={classNames(styles.wrapper, { [styles.highlighted]: highlighted })}>
        <div className={styles.name}>{name}</div>
        <p className={styles.description}>{description}</p>
        <div className={styles.priceHolder}>
          <div>${price}</div>
          <div>per month</div>
        </div>
        {features}
        {upgradeButton}
        <span className={styles.footer}>Upgrade or cancel at any time</span>
      </div>
    </div>
  );
};

export default PricingCard;
